// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	IConsultarStatusMainframeDareState,
	Types,
	IStatusDareMainframeRequest,
} from './types';

export function consultarStatusDareMainframeRequest(
	token: string,
	payload: IStatusDareMainframeRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_STATUS_DARE_MAINFRAME_REQUEST,
		token,
		payload,
	};
}

export function consultarStatusDareMainframeSuccess(
	status: number,
	data: IConsultarStatusMainframeDareState | null,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_STATUS_DARE_MAINFRAME_SUCCESS,
		payload: {
			status,
			data,
		},
	};
}

export function consultarStatusDareMainframeFailure(
	status: number,
	data: null,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_STATUS_DARE_MAINFRAME_FAILURE,
		payload: {
			status,
			data,
		},
	};
}

export function consultarStatusDareMainframeClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_STATUS_DARE_MAINFRAME_CLEAR,
		payload: null,
	};
}
